import { ShiftsServiceInterface } from 'domain/services';
import { GetAllShiftsUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  getAllShifts: GetAllShiftsUseCaseInterface;
}

export class ShiftsService implements ShiftsServiceInterface {
  private readonly _getAllShifts: GetAllShiftsUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllShifts = usecases.getAllShifts;
  }

  getAllShifts(): Promise<GetAllShiftsUseCaseInterface.Result> {
    return this._getAllShifts.execute();
  }
}
